import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { includes, isArray } from 'lodash-es';

import { AddressEnum } from '../../../enums/address';
import { MainTabBasePathEnum } from '../../../enums/main-tabs';
import { ProfileSearchEnum } from '../../../enums/profile-search';
import * as fromPropertyProfileActions from '../../../store/actions/property-profile.actions';
import { ProfileLocation } from '../../../store/models/property-profile.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-profile-details',
  standalone: false,
  templateUrl: './multiple-results.page.html'
})
export class MultipleResultsPageComponent {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private store = inject(Store);

  addressType = AddressEnum;
  locations: ProfileLocation[];
  defaultBackHref: string | undefined;
  constructor() {
    this.defaultBackHref = this.activatedRoute.snapshot.data['defaultBackHref'] ?? MainTabBasePathEnum.PropertySearch;
    const locations = this.router.currentNavigation()?.extras?.state?.['locations'];
    this.locations = isArray(locations) ? locations : [];
  }

  loadProfile(location: ProfileLocation) {
    this.store.dispatch(
      fromPropertyProfileActions.loadProfileByAPN({
        payload: {
          apn: location.APN ?? '',
          county: location.county ?? '',
          searchType: includes(this.defaultBackHref, MainTabBasePathEnum.WalkingFarm)
            ? ProfileSearchEnum.WalkingFarm
            : ProfileSearchEnum.PropertySearch,
          state: location.State ?? ''
        }
      })
    );
  }
}
